module.exports = {
    PREVIEWABLE_FIELDS: [/application\/pdf/, /image\/[a-zA-Z]*/]
}
